<template>
    <div>
        <div class="full-content" style="background-image:url('assets/img/bg-gaspol-1.jpg')">
            <div class="d-flex align-items-center justify-content-center h-100 py-5">
                <div class="container-fluid">
                    <div class="row justify-content-center">
                        <div class="col-lg-5 col-md-8 col-11">
                            <div class="card border bg-card-trans m-0">
                                <div class="card-body border-bottom">
                                    <div class="d-flex flex-column p-3">
                                        <div class="d-block mb-4">
                                            <img src="assets/img/gaspol-ptn-logo-dark.svg" height="60">
                                        </div>
                                        <!--div class="card mb-0">
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div class="d-block display-tektur h2 m-0">Selamat Datang</div>
                                                    <div class="d-flex align-items-center">
                                                        <div class="d-block overflow-hidden">
                                                            <div class="d-block text-pink font-bold">Admin</div>
                                                        </div>
                                                        <div class="d-block ms-3">
                                                            <div class="avatar avatar-xs">
                                                                <span class="avatar-title rounded-circle bg-pink text-dark"><i class="fa-solid fa-user fa-lg m-0"></i></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div-->
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="d-block p-3">
                                        <form class="form-horizontal" v-on:submit.prevent="onSubmit">
                                            <div class="form-group form-style-1">
                                                <label class="form-label">Username</label>
                                                <input type="text" class="form-control" placeholder="Masukan username" v-model="username" required oninvalid="this.setCustomValidity('Masukan username')" oninput="this.setCustomValidity('')">
                                            </div>
                                            <div class="form-group form-style-1">
                                                <label class="form-label">Kata Sandi</label>
                                                <input type="password" class="form-control" placeholder="Masukan kata sandi" v-model="password" required oninvalid="this.setCustomValidity('Masukan password')" oninput="this.setCustomValidity('')">
                                            </div>
                                            <div class="d-flex justify-content-end pt-3">
                                                <button :disabled="waiting" type="submit" class="btn btn-primary btn-lg btn-s-1">
                                                    <div class="btn-s-1-inner" v-if="waiting">Loading... <i class='fa-solid fa-spin fa-spinner fa-lg ms-3'></i></div>
                                                    <div class="btn-s-1-inner" v-if="!waiting">Masuk ke Aplikasi<i class='fa-solid fa-arrow-right fa-lg ms-3'></i></div>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
<script>
    import {
        required
    } from "vuelidate/lib/validators";

  export default {
    name: 'SigninView',
    metaInfo: {
        title: 'Signin',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    data() {
        return {
            username: "",
            password: "",
            submitted: false,
            waiting: false,
        }
    },
    validations: {
        username: {
            required
        },
        password: {
            required
        }
    },
    methods: {
        onSubmit: function () {
            this.waiting = true;
            this.submitted = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Harap lengkapi form',
                });

                this.waiting = false;
                return;
            } else {
                this.$http.post(process.env.VUE_APP_APIHOST + 'auth/signin', {
                        username: this.username,
                        password: this.password
                    })
                    .then(response => {
                        this.waiting = false;

                        if (response.data.status) {
                            const token = response.data.user.key;
                            localStorage.setItem('gaspol_token', token);
                            location.reload();
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                    })
            }
        }
    }
  }
  </script>
  